;(function ($) {

  window.addEventListener('DOMContentLoaded', () => {
    formatSaveTheDate()
  })

  const formatSaveTheDate = () => {
    if (!document.querySelector('body.single-tribe_events')) return


    // console.log('single page event')
  }


})(jQuery)
